export type NormalizedCastMember = {
  id: number;
  name: string;
  character: string;
  profilePath: string | null;
};

const MAX_CAST = 12;

export function normalizeMovieCast(
  cast: Array<{
    id: number;
    name: string;
    character?: string;
    order?: number | null;
    profile_path?: string | null;
  }> | undefined,
): NormalizedCastMember[] {
  if (!Array.isArray(cast) || cast.length === 0) {
    return [];
  }
  const filtered = cast.filter(
    (c) => c && typeof c.id === "number" && c.order != null,
  );
  const pool =
    filtered.length > 0
      ? [...filtered].sort((a, b) => (a.order ?? 999) - (b.order ?? 999))
      : cast.filter((c) => c && typeof c.id === "number");
  return pool.slice(0, MAX_CAST).map((c) => ({
    id: c.id,
    name: c.name || "Unknown",
    character: c.character?.trim() || "—",
    profilePath: c.profile_path ?? null,
  }));
}

export function normalizeTvAggregateCast(
  cast:
    | Array<{
        id: number;
        name: string;
        profile_path?: string | null;
        roles?: Array<{ character?: string }>;
      }>
    | undefined,
): NormalizedCastMember[] {
  if (!Array.isArray(cast) || cast.length === 0) {
    return [];
  }
  return cast.slice(0, MAX_CAST).map((c) => {
    const character =
      c.roles?.map((r) => r.character).filter(Boolean).join(" / ") || "—";
    return {
      id: c.id,
      name: c.name || "Unknown",
      character: String(character),
      profilePath: c.profile_path ?? null,
    };
  });
}
